import { Grid } from '@mui/material'

import { CardTitle } from 'components/common'

interface IContainerTitleProps {
  isQuote?: boolean
  disabled?: boolean
}

const ContainerTitle = (props: IContainerTitleProps) => {
  const { isQuote, disabled } = props

  return (
    <Grid item>
      <CardTitle marginBottom={isQuote ? 0 : 1} disabled={disabled}>
        Main Details
      </CardTitle>
    </Grid>
  )
}

export default ContainerTitle
